module.exports = __webpack_public_path__ + "static/media/guinsoolab-security.5aefe97b.svg";